function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip_chevron_up)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 14.869a.75.75 0 01-1.293.517L10 6.22l-8.706 9.165A.751.751 0 01.207 14.35l9.25-9.737a.75.75 0 011.088 0l9.25 9.737a.753.753 0 01.206.518z",
  fill: "#00253E"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip_chevron_up"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h20v20H0V0z",
  fill: "#fff"
})))));